// @flow
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { scrollX } from '@finect/tabular-utils/scrollX';

export const TopAnswers = styled(Flex)`
  ${scrollX}
`;
